import React, { useState, useRef, useEffect } from "react";
import { Card, Col, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { faExpand, faCompress } from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ViewerV2 from "../../components/ViewerV2/components/Viewer";

function Viewer() {
    let { caseid } = useParams();
    const [isFullWindow, setIsFullWindow] = useState(false);

    // Reference to the ViewerV2 component to call methods on it
    const viewerRef = useRef(null);
    
    const toggleFullWindow = () => {
        setIsFullWindow(!isFullWindow);
    };
    
    // Handle resize after full window state changes
    useEffect(() => {
        // Add a small delay to allow the UI to update first
        const timeoutId = setTimeout(() => {
            // If the viewerRef has a current value and that has a handleResize method, call it
            if (viewerRef.current && viewerRef.current.handleResize) {
                console.log("Triggering resize after fullscreen change");
                viewerRef.current.handleResize();
            }
        }, 300); // 300ms delay
        
        return () => clearTimeout(timeoutId);
    }, [isFullWindow]);

    const getColStyles = () => {
        const compStyle = {
            position: isFullWindow ? "fixed" : "relative",
            top: isFullWindow ? 0 : "auto",
            left: isFullWindow ? 0 : "auto",
            height: isFullWindow ? "100vh" : "auto",
            zIndex: isFullWindow ? 1000 : "auto",
            backgroundColor: isFullWindow ? "white" : "transparent",
        };
        if (isFullWindow){
            compStyle['width'] = '100vw';
        }

        return compStyle;
    };


    return (
        <>
            <Col
                xs={{ span: 11 }}
                className=""
                style={getColStyles()}
            >
                <Card
                    style={{
                        height: isFullWindow ? "100%" : "100%",
                        minHeight: isFullWindow ? "100vh" : 1000,
                    }}
                >
                    <Card.Body
                        style={{
                            position: "absolute",
                            height: "90%",
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <h4>Viewer</h4>
                            <Button variant="primary" onClick={toggleFullWindow}>
                                <FontAwesomeIcon
                                    icon={isFullWindow ? faCompress : faExpand}
                                />
                            </Button>
                        </div>
                        <ViewerV2 ref={viewerRef} case={caseid} />
                        {/*<ViewerComponent*/}
                        {/*    case={caseid}*/}
                        {/*    showGS={true}*/}
                        {/*    showST={true}*/}
                        {/*/>*/}
                    </Card.Body>
                </Card>
            </Col>
        </>
    );
}

export default Viewer;